module.exports = __webpack_public_path__ + "static/media/helically_formed_top_tie.065e2961.webp";